import React from 'react'
import Box from '@mui/material/Box'
import { ErrorBoundary } from '../'

interface ButtonContainerProps {
  marginTop?: number
  primary?: JSX.Element
  secondary?: JSX.Element
  middle?: JSX.Element
  className?: string
}

const ButtonContainer: React.FunctionComponent<ButtonContainerProps> = ({
  marginTop = 2,
  primary,
  secondary,
  middle,
  className,
}) => {
  const marginRight = secondary ? 3 : middle ? 2 : 0

  return (
    <ErrorBoundary>
      {(primary || secondary || middle) && (
        <Box
          sx={{
            marginTop,
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'flex-start' },
            '& > *': {
              marginRight: marginRight,
            },
            ...(className && { className: className }),
          }}
        >
          {primary && <Box sx={{ marginRight }}>{primary}</Box>}
          {middle && <Box sx={{ marginRight }}>{middle}</Box>}
          {secondary && <Box>{secondary}</Box>}
        </Box>
      )}
    </ErrorBoundary>
  )
}

export default ButtonContainer
